import { QueryClient } from '@tanstack/react-query';
import type { AxiosError } from 'axios';

const isNetworkError = (error: AxiosError) => !error.response && !error.code;

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      retry: false,
    },
    mutations: {
      throwOnError: false,
      retry: (failureCount, error) =>
        isNetworkError(error as AxiosError) && failureCount < 2,
    },
  },
});
